import { Component } from '@angular/core';

interface TeamMember {
  id: string;
  name: string;
  role: string;
  secondRole?: string;
  imageSrc: string;
  imageAlt: string;
}

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})
export class TeamComponent {
  teamMembers: TeamMember[] = [
    {
      id: 'sc',
      name: 'Stefan Cadosch',
      role: 'products.team.architect',
      secondRole: 'products.team.cco',
      imageSrc: '/assets/images/team/sc.avif',
      imageAlt: 'SC',
    },
    {
      id: 'tl',
      name: 'Tobias Lüscher',
      role: 'products.team.ceo',
      imageSrc: '/assets/images/team/tl.avif',
      imageAlt: 'TL',
    },
    {
      id: 'mi',
      name: 'Michael Imbach',
      role: 'products.team.lead_dev',
      secondRole: 'products.team.cto',
      imageSrc: '/assets/images/team/mi.avif',
      imageAlt: 'MI',
    },
    {
      id: 'mb',
      name: 'Mischa Badertscher',
      role: 'products.team.architect',
      secondRole: 'products.team.cpo',
      imageSrc: '/assets/images/team/mb.avif',
      imageAlt: 'MB',
    },
    {
      id: 'ys',
      name: 'Yvonne Schärli',
      role: 'products.team.architect_female',
      secondRole: 'products.team.pm',
      imageSrc: '/assets/images/team/ys.avif',
      imageAlt: 'YS',
    },
    {
      id: 'jc',
      name: 'Juan Crevillén',
      role: 'products.team.architect',
      secondRole: 'products.team.dm',
      imageSrc: '/assets/images/team/jc.avif',
      imageAlt: 'JC',
    },
    {
      id: 'fe',
      name: 'Freskim Elmazi',
      role: 'products.team.fsd',
      imageSrc: '/assets/images/team/fe.avif',
      imageAlt: 'FE',
    },
    {
      id: 'sb',
      name: 'Sean Blackburn',
      role: 'products.team.fsd',
      imageSrc: '/assets/images/team/sb.avif',
      imageAlt: 'SB',
    },
    {
      id: 'ag',
      name: 'Alexander Gogas',
      role: 'products.team.de',
      imageSrc: '/assets/images/team/ag.avif',
      imageAlt: 'AG',
    },
    {
      id: 'dh',
      name: 'Daniel Hunziker',
      role: 'products.team.head-of-sales',
      imageSrc: '/assets/images/team/dh.avif',
      imageAlt: 'DH',
    },
    {
      id: 'tc',
      name: 'Tamara Czerny',
      role: 'products.team.sm',
      imageSrc: '/assets/images/team/tc.avif',
      imageAlt: 'TC',
    },
    {
      id: 'bt',
      name: 'Beat Theiler',
      role: 'products.team.sm',
      imageSrc: '/assets/images/team/bt.avif',
      imageAlt: 'BT',
    },
    {
      id: 'dn',
      name: 'Daphnée Navarro',
      role: 'products.team.sales_romandie',
      imageSrc: '/assets/images/team/dn.avif',
      imageAlt: 'DN',
    },
    {
      id: 'thh',
      name: 'Thomas Henking',
      role: 'products.team.key_account_romandie',
      imageSrc: '/assets/images/team/thh.avif',
      imageAlt: 'THH',
    },
    {
      id: 'am',
      name: 'Aniket Mandal',
      role: 'products.team.fsd',
      imageSrc: '/assets/images/team/am.avif',
      imageAlt: 'AM',
    },
  ];
}
